import { EntityType, EntityTypeNames } from './entity-type.enum'

export enum ErrorMessage {
  RELEASE_NOT_FOUND = 'Release not found',
  AI_CANNOT_EXTRACT_COMPONENTS = 'Failed to extract components',
  THREAD_NOT_FOUND = 'Thread not found',
  COMMENT_BELONGS_TO_OTHER_USER = 'Cannot update comment of another user',
  ROLE_NOT_FOUND = 'Role not found',
  TEAM_MEMBER_NOT_FOUND = 'Team member not found',
  USER_NOT_FOUND = 'User not found',
  INVITER_NOT_FOUND = 'Inviter not found',
  INVITATION_TOKEN_NOT_FOUND = 'Invitation token not found',
  EMAIL_DOMAIN_NOT_MATCH_VERIFIED = 'Email domain doesn\'t match verified domain.',
  FREE_EMAIL_DOMAIN_NOT_SUPPORTED = 'Free email domain can\'t be added.',
  INVALID_TOKEN = 'Invalid token',
  INVITATION_IS_ALREADY_ACCEPTED = 'User already accepted invitation',
  USER_IS_NOT_A_MEMBER = 'User not member of workspace',
  WORKSPACE_MEMBER_NOT_FOUND = 'Workspace member not found',
  TEAM_NOT_FOUND = 'Team not found',
  FAILED_TO_LOGIN = 'Failed to login',
  INVALID_LINKING_USER_ID = 'Invalid linking user id.',
  EMAIL_ALREADY_USED = 'Email already used. Login and link accounts.',
  EMAIL_NOT_CONFIRMED = 'Email not confirmed',
  EMAIL_DOMAIN_NOT_ALLOWED = 'Email domain is not allowed.',
  SESSION_NOT_FOUND = 'Session not found',

  NOT_AUTHORIZED = 'User is not authorized',
  NOT_ENABLED = 'User is not enabled',
  AUTH_FAILED = 'Authorization failed',
  INVALID_PASSWORD_OR_EMAIL = 'Invalid password or email',
  USER_ACCOUNT_BLOCKED = 'User account blocked. Try again later.',
  INTERNAL_ERROR = 'Internal server error',
  DEFAULT_BRANCH_MISSED = 'Default branch is missed',
  INVALID_REQUEST = 'Invalid request',
  ENTITY_WAS_REMOVED = 'Entity was removed',

  PROJECT_NOT_FOUND = 'Project not found',
  ISSUE_NOT_FOUND = 'Issue not found',
  ALERT_RULE_NOT_FOUND = 'Alert rule not found',
  AGENT_NOT_FOUND = 'Agent not found',
  GIT_REPOSITORY_NOT_FOUND = 'Git repository not found',
  WORKSPACE_NOT_FOUND = 'Workspace not found',
  SOURCE_ENTITY_NOT_FOUND = 'Source entity not found',
  TARGET_ENTITY_NOT_FOUND = 'Target entity not found',
  ENTITY_NOT_FOUND = 'The requested entity could not be found',
  ENTITY_COMMIT_NOT_FOUND = 'The requested entity commit could not be found',
  ENTITY_STATE_IN_BRANCH_NOT_FOUND = 'The requested entity could not be found in branch',
  ENTITY_COMMIT_CONTENTS_NOT_FOUND = 'The requested content file could not be found',
  RESTRICTED_ENTITY_COMMIT_CONTENTS_ROUTE = 'Route is not applicable for selected entity commit',
  INTERNAL_ERROR_NO_REQUIRED_DATA = 'Required data is missing',
  INTERNAL_ERROR_NO_PARENT_BRANCH = 'Parent project branch was not found',
  INTERNAL_ERROR_NO_PARENT_ENTITY_STATE = 'Previous entity state is missing',
  INTERNAL_ERROR_NO_PARENT_ENTITY_COMMIT = 'Failed to get parent entity commit',
  INTERNAL_ERROR_NO_PARENT_COMMIT = 'Failed to get parent commit',
  INTERNAL_ERROR_INVALID_COMMIT_CHANGE_TYPE = 'Invalid entity commit change type',
  FROM_BRANCH_STATE_NOT_FOUND = 'Last commit from branch not found',
  TO_BRANCH_STATE_NOT_FOUND = 'Last commit to branch not found',
  ENV_NOT_FOUND = 'Environment not found',
  PROJECT_BRANCH_NOT_FOUND = 'Project branch not found',
  PROJECT_BRANCH_REVIEW_NOT_FOUND = 'Project branch review not found',
  NON_DEFAULT_BRANCH_ONLY = 'Operation is allowed only for non-default branches',
  NO_BRANCH_TREE = 'Failed to fetch project branch tree',
  UNAVAILABLE_FOR_MERGE_BRANCH = 'Operation is not allowed for MERGED branch',
  DESTINATION_BRANCH_NOT_FOUND = 'Destination branch not found',
  SOURCE_BRANCH_NOT_FOUND = 'Source branch not found',
  MERGE_DEFAULT_BRANCH_ONLY = 'Only from/to default branch merge allowed',
  MERGE_SAME_BRANCH_NOT_ALLOWED = 'Cannot use the same branch as destination and source',
  USE_BRANCHES_FROM_THE_SAME_PROJECT = 'Branches should belong to the same project',
  RESOLVE_CONFLICTS = 'Conflicts should be resolved before merge into default branch',
  LINK_NOT_FOUND = 'Project link not found',
  INTEGRATION_NOT_FOUND = 'Integration not found',
  TAG_NOT_FOUND = 'Project tag not found',
  VARIABLE_SCHEMA_NOT_FOUND = 'Variable-Schema not found',
  VARIABLE_VAlUE_NOT_FOUND = 'Variable-value not found',
  WORKSPACE_USER_NOT_FOUND = 'Workspace user not found',
  ENTITY_COMMIT_IS_NOT_ATTACHABLE = 'Entity-Commit is not attachable.',
  NO_ACCESS_TO_THE_RESOURCE = 'No access to the resource',
  CANNOT_VERIFY_COMMIT_CONTENT = 'Failed to verify commit content',
  ACTION_NOT_ALLOWED = 'Action is not allowed',
  CANNOT_EDIT_PUBLIC_REPO = 'Cannot edit public repository',

  FEATURE_LIMITED_BY_BILLING_PLAN = 'Feature limited by billing plan. Upgrade to use it.',

  CHAT_NOT_FOUND = 'Chat not found',
}

export const ErrorMessageWithParams = {
  NO_ALIAS_DUPLICATES: (alias: string, key: string, type: EntityType) => {
    return `Aliases should be unique. '${alias}' is used in ${EntityTypeNames[type]}:${key}`
  },
}
